/**
 * The post a save is made from, so the save credits it
 * (docs/plans/POST_SAVE_ATTRIBUTION.md).
 *
 * Saving from someone's activity post saves the PLACE — that is what the
 * saved row is keyed on, and what the Saved page and planner read. This names
 * the post it was found in, which the save carries alongside. Null for
 * anything that isn't someone's activity post (a place, a landmark, an event,
 * the viewer's own post).
 *
 * The server re-checks all of it: the post exists, the viewer can see it, it
 * is about the place being saved, and the viewer isn't its author. A wrong
 * guess here only costs that check.
 */
export function activityPostFoundVia(item) {
  if (!item || item.is_own_content) return null;
  if (item.content_type && item.content_type !== 'activity') return null;
  const id = item.activity_id || item.id;
  // A post has an author; a search result has none. A hidden author's stop
  // goes out with no user_id but marked former_member (round 32 C380 A2), and
  // still credits its post (self-review D7) — the server re-checks it.
  if (!id || !item.place_id || (!item.user_id && !item.former_member) || String(id) === String(item.place_id)) return null;
  return { type: 'activity', id: String(id) };
}

/**
 * The trip, album, collection or board a place is saved from, so the save
 * credits it — the post the saver was looking at (an album credits the album,
 * not its trip). Null when the viewer is its creator or one of its own people:
 * their saves never count. The server re-checks that the place is in it.
 */
export function containerFoundVia(type, id, { viewerIsInside = false } = {}) {
  if (!id || viewerIsInside) return null;
  return { type, id: String(id) };
}

/** Is this user the trip's owner or one of its accepted travellers? */
export function isOnTrip(trip, userId) {
  if (!trip || !userId) return false;
  if (trip.user_id && String(trip.user_id) === String(userId)) return true;
  return (trip.travelers || []).some(t =>
    String(t.user_id) === String(userId) && (t.role === 'owner' || t.status === 'accepted'));
}
